import { styled } from "../../../../styles";

/**
 * The executed-step timeline (EN-5167). A vertical rail with a marker per
 * step: the run is a sequence of things that happened, so it reads as a
 * timeline rather than the tree the ticket assumed.
 */
export const Timeline = styled("ol", {
  listStyle: "none",
  margin: "0",
  padding: "0 0 0 20px",
  borderLeft: "2px solid $gray-30",
  display: "flex",
  flexDirection: "column",
  gap: "20px",
});

export const TimelineItem = styled("li", {
  position: "relative",

  "&::before": {
    content: '""',
    position: "absolute",
    left: "-27px",
    top: "6px",
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    border: "2px solid $white",
    backgroundColor: "$gray-60",
  },

  variants: {
    done: {
      true: { "&::before": { backgroundColor: "$success" } },
    },
  },
});

export const TimelineHeader = styled("div", {
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: "8px",
  marginBottom: "4px",
});

export const TimelineTime = styled("span", {
  fontSize: "12px",
  fontFamily: "$openSans",
  color: "$gray-80",
});

export const TimelineTitle = styled("span", {
  fontSize: "14px",
  fontWeight: 600,
  fontFamily: "$openSans",
  color: "$charcoal",
});

export const TimelineBody = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  fontSize: "13px",
  fontFamily: "$openSans",
  color: "$charcoal",
});

/** The patient-facing text a step sent or asked. */
export const StepQuote = styled("p", {
  margin: "0",
  padding: "8px 10px",
  borderRadius: "4px",
  backgroundColor: "$gray-10",
  border: "1px solid $gray-30",
  fontSize: "13px",
  fontFamily: "$openSans",
  color: "$charcoal",
});

export const StepDetail = styled("span", {
  fontSize: "12px",
  fontFamily: "$openSans",
  color: "$gray-80",
});

/** Chip list — a rule's measurement types, a question's options. */
export const StepTags = styled("span", {
  display: "inline-flex",
  flexWrap: "wrap",
  gap: "4px",
});

export const StepTag = styled("span", {
  padding: "1px 8px",
  borderRadius: "10px",
  backgroundColor: "$gray-20",
  border: "1px solid $gray-30",
  fontSize: "12px",
  fontFamily: "$openSans",
  color: "$charcoal",
  whiteSpace: "nowrap",

  variants: {
    chosen: {
      true: {
        backgroundColor: "$success-light",
        borderColor: "$success",
        fontWeight: 600,
      },
    },
  },
});
